import Text from '@atoms/Text';
import Link from '@atoms/Link';
import { useRouter } from 'next/router';
import Button from '@atoms/Button';
import texts from './en.json';
import AccordionItem from '@components/Faq/accordionItem';
import DesignSystemButton from '@ui/atoms/design-system/Button';

const ProductFAQs = ({
    selectedProduct,
    isDesignSystemButton = false,
    buttonType,
}) => {
    const { productFaqs } = selectedProduct;
    const { disclaimer, urlId, title } = productFaqs;
    const router = useRouter();

    return (
        <section
            id={`product-faq`}
            className="w-full px-4 md:px-10 xl:px-16"
        >
            <div className="relative flex flex-col items-center py-10 md:py-12">
                <Text
                    content={productFaqs?.faqs ? 'FAQs' : texts?.HaveMoreQuestions}
                    htmlTag="h3"
                    className={`z-50 ${productFaqs?.faqs ? 'h2-semibold' : 'h4-semibold md:h3-semibold xl:h2-semibold'} text-primary-500`}
                />
                {title ? (
                    <Text
                        content={`${texts?.CheckOutFaqs} ${
                            title ? ` on ${title}` : ''
                        }`}
                        htmlTag="p"
                        className="z-50 mt-4 text-basicBlack p4-regular md:p3-regular xl:p2-regular text-center"
                    />
                ) : null}

                {productFaqs?.faqs && (
                    <div className='self-start w-full flex flex-col gap-4 mt-8'>
                        {productFaqs?.faqs?.map((faq, index) => (
                            <AccordionItem {...faq} key={index} defaultOpen={true}/>
                        ))}
                    </div>
                )}

                {!isDesignSystemButton ? (
                    <Button
                        design="standard"
                        type="primary"
                        onClick={() => {
                            router.push(`/faq#${urlId}`);
                        }}
                        gtmTag={productFaqs?.gtmTag}
                        className="text-center text-basicWhite
                                bg-primary-500 z-40 !rounded-[31px]
                                mt-6 py-3 px-6 md:py-4 md:px-8"
                    >
                        <Text
                            content={
                                productFaqs?.faqs
                                    ? texts?.ViewAllFaqs
                                    : texts?.ViewFaqs
                            }
                            htmlTag="p"
                            className="p3-semibold md:p2-semibold text-basicWhite"
                        />
                    </Button>
                ) : (
                    <div className='mt-6'>
                        <DesignSystemButton
                            buttonText={
                                productFaqs?.faqs
                                    ? texts?.ViewAllFaqs
                                    : texts?.ViewFaqs
                            }
                            buttonType={buttonType}
                            onClick={() => {
                                router.push(`/faq#${urlId}`);
                            }}
                        />
                    </div>
                )}
            </div>
            {disclaimer ? 
                <div className="z-50 py-6 md:py-10 text-gray-600 p4-regular md:p3-regular">
                    <Text
                        htmlTag="label"
                        content={disclaimer?.[0]}
                        className="z-50"
                    />
                    <Link
                        href="/risk-disclosure" className="z-50 text-primary-500 p4-underline md:p3-underline cursor-pointer"
                        gtmTag='gtm-click-risk-disclosure'
                        children={disclaimer?.[1]} />
                    <Text
                        htmlTag="label"
                        content={disclaimer?.[2]}
                        className="z-50"
                    />
                </div> 
            : null}
        </section >
    );
};

export default ProductFAQs;
